import { FirebaseError } from 'firebase/app';
import { collection, getDocs, query, where } from 'firebase/firestore';

import { db } from '../../config';

export const fetchAttractions = async (
  associationIds: string[],
): Promise<any[]> => {
  if (!associationIds.length) {
    throw new FirebaseError('invalid-argument', 'No IDs provided');
  }

  const collectionRef = collection(db, 'attractions');

  const q = query(
    collectionRef,
    where('id', 'in', associationIds), // Filtering by ID array
  );

  const snapshot = await getDocs(q);

  if (snapshot.empty) {
    return [];
  }

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};
